import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import AWSAppSyncClient from 'aws-appsync';
import { ApolloProvider } from 'react-apollo';
import { Rehydrated } from 'aws-appsync-react';
import configureStore from 'utils/configureStore';
import history from 'utils/history';
import App from './App';
import './index.less';
import amplifyPublicConfig from './aws-exports-public';

const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');

const publicApiClient = new AWSAppSyncClient({
  url: amplifyPublicConfig.public_graphql_api_url,
  region: amplifyPublicConfig.public_graphql_api_region,
  auth: {
    type: 'API_KEY',
    apiKey: amplifyPublicConfig.public_graphql_api_api_key,
  },
});
const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ApolloProvider client={publicApiClient}>
          <Rehydrated>
            <App />
          </Rehydrated>
        </ApolloProvider>
      </ConnectedRouter>
    </Provider>,
    MOUNT_NODE,
  );
};

if (module.hot) {
  module.hot.accept(['./App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}

render();
